document.addEventListener('click', function(e) {
  if (e.target.matches('.mobile-facets__footer .button--primary')) {

    const drawer = e.target.closest('menu-drawer');
    const details = drawer.querySelector('details.mobile-facets__disclosure');

    if (details) {
      details.removeAttribute('open');
    }
  }
});

  document.querySelectorAll('.product__info-wrapper .product__text').forEach(el => {
  if (!el.textContent.trim()) {
    el.style.display = 'none';
  }
});

